import { defineMessages } from 'utils/intl';

export default defineMessages({
  companyData: 'NIP: {nip}, REGON: {regon}',
});
